import { useNavigate, useLocation } from 'react-router-dom'

export const useScroll = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const scrollToBlock = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/')
    }

    setTimeout(() => {
      const element = document.getElementById(sectionId)
      if (element) {
        const headerHeight = document.querySelector('header').offsetHeight
        const topOffset = element.offsetTop - headerHeight

        window.scrollTo({
          top: topOffset,
          behavior: 'smooth'
        })
      }
    }, 0)
  }

  return { scrollToBlock }
}